<template>
  <el-container id="myapp" direction="vertical">
    <el-main style="padding:20px 10px 10px 10px;">
      <div class="toparea">
        <div style="margin:10px" class="topinput">
          <!-- <transition-group name="datetrans" class="topinput"> -->
          <el-date-picker
            v-model="date"
            type="date"
            placeholder="选择微博日期"
            value-format="yyyy-MM-dd"
            format="yyyy 年 MM 月 dd 日"
            v-show="datepickshow"
            @change="datepage"
            key="date"
            id="datepick"
          ></el-date-picker>
          <div class="search" key="search">
            <el-input
              class="inputbox"
              prefix-icon="el-icon-search"
              placeholder="搜索微博内容"
              v-model="search"
              @focus="inputboxfocus"
              clearable
              key="inputbox"
              @keyup.enter.native="dosearch"
            ></el-input>
            <el-button
              v-show="searchbutton"
              type="primary"
              icon="el-icon-search"
              @click="dosearch"
              key="searchbutton"
            >搜索</el-button>
          </div>
          <!-- </transition-group> -->
        </div>
      </div>
      <el-alert v-if="load" title="正在加载..." type="info" :closable="false"></el-alert>
      <el-alert v-if="nosearch" title="搜不到呀，换个词吧 XD" type="error" :closable="false"></el-alert>
      <el-alert v-if="nocollection" title="还没有收藏 (/▽＼)" type="error" :closable="false"></el-alert>
      <el-alert v-if="loginerror" title="登录以后刷新一下(●ˇ∀ˇ●)" type="error" :closable="false"></el-alert>
      <el-alert v-if="loaderror" title="加载失败，请刷新页面" type="error" :closable="false">
        <p style="text-align:center">
          <a class="loaderror" href="/">刷新</a>
        </p>
      </el-alert>
      <el-alert v-if="nodata" title="没有这一天的数据 : (" type="error" :closable="false"></el-alert>

      <div id="wbcontent">
        <normalweibo
          v-for="(item ,index) in info"
          :key="index"
          :post="item"
          class="item"
          @homefavorite="homefavorite(item.weiboID,item.favorite,item)"
        ></normalweibo>
      </div>
    </el-main>

    <el-button-group>
      <el-button
        type="primary"
        icon="el-icon-arrow-left"
        :disabled="predisable"
        @click="prepage"
      >上一页</el-button>
      <el-button type="primary" @click="nextpage" :disabled="nextdisable">
        下一页
        <i class="el-icon-arrow-right el-icon--right"></i>
      </el-button>
      <el-button type="primary" @click="backTop">回到顶部</el-button>
    </el-button-group>
    <!-- <el-footer>Powered By Microsoft Azure:)</el-footer> -->
  </el-container>
</template>

<script>
import Request from "../api/request.js";
import * as Msal from "../../node_modules/msal";
var pagesize = 10;
var applicationConfig = {
  clientID: "d327cb85-7aa0-4cd6-8015-16c89af9078e",
  authority:
    "https://repeater.b2clogin.com/tfp/repeater.onmicrosoft.com/B2C_1_SiUpIn",
  b2cScopes: ["https://repeater.onmicrosoft.com/repeater/user_impersonation"],
  webApi: "https://repeater.azurewebsites.net/repeater"
};
// ("use strict");
var clientApplication = new Msal.UserAgentApplication(
  applicationConfig.clientID,
  applicationConfig.authority,
  function(errorDesc, token, error, tokenType) {
    // Called after loginRedirect or acquireTokenPopup
  },
  {
    storeAuthStateInCookie: true
  }
);
function load_page(date, page) {
  if (date != null) {
    return res;
  }
}
function runScroll() {
  scrollTo(document.body, 0, 300);
}
function scrollTo(element, to, duration) {
  if (duration <= 0) return;
  var difference = to - element.scrollTop;
  var perTick = (difference / duration) * 10;

  setTimeout(function() {
    element.scrollTop = element.scrollTop + perTick;
    if (element.scrollTop == to) return;
    scrollTo(element, to, duration - 10);
  }, 10);
}

import normalweibo from "./weiboitem/NormalWeibo.vue";
export default {
  components: {
    normalweibo
  },
  data() {
    return {
      info: "",
      page: 1,
      date: "",
      search: "",
      datepickshow: false,
      searchbutton: false,
      load: true,
      nodata: false,
      nomore: false,
      loaderror: false,
      loginerror: false,
      nocollection: false,
      nosearch: false
    };
  },
  computed: {
    predisable: function() {
      if (this.page === 1) {
        return true;
      }
      return false;
    },
    nextdisable: function() {
      if (this.info == null || this.info.length < pagesize) {
        return true;
      }
      if (!this.nomore) {
        return false;
      }
      return true;
    }
  },
  async mounted() {
    await this.fetchtoken();
    this.loaddata();
    this.$globalevent.$on("login", async () => {
      console.log("login");
      await this.fetchtoken();
      await this.loaddata();
    });
  },
  methods: {
    //下一页
    nextpage() {
      this.setvisualflag("loading");
      if (this.search.trim() != "") {
        this.$request
          .searcharticle(this.token, this.search.trim(), ++this.page)
          .then(response => {
            var flag = this.checkresponse(response);
            this.checkflag(flag);
            this.backTop();
          });
      } else {
        this.$request.favorite(this.token, ++this.page).then(response => {
          var flag = this.checkresponse(response);
          this.checkflag(flag);
          this.backTop();
        });
      }
    },
    //上一页
    prepage() {
      this.setvisualflag("loading");
      if (this.search.trim() != "") {
        this.$request
          .searcharticle(this.token, this.search.trim(), --this.page)
          .then(response => {
            var flag = this.checkresponse(response);
            this.checkflag(flag);
            this.backTop();
          });
      } else {
        this.$request.favorite(this.token, --this.page).then(response => {
          var flag = this.checkresponse(response);
          this.checkflag(flag);
          this.backTop();
        });
      }
    },
    backTop() {
      var gotoTop = function() {
        var currentPosition =
          document.documentElement.scrollTop || document.body.scrollTop;
        currentPosition -= 30;
        if (currentPosition > 0) {
          window.scrollTo(0, currentPosition);
        } else {
          window.scrollTo(0, 0);
          clearInterval(timer);
          timer = null;
        }
      };
      var timer = setInterval(gotoTop, 1);
    },
    datepage() {
      this.loaderror = false;
      this.page = 1;
      this.nomore = false;
      this.nodata = false;
      this.load = true;
      this.search = "";
      if (this.date != "") {
        var arr = this.date.split("-");
        var year = arr[0];
        var month = arr[1];
        var day = arr[2];
        this.$request
          .articlebydate(year, month, day, this.page)
          .then(response => {
            this.info = response.data;
            this.load = false;
            if (!this.info) {
              this.nodata = true;
            } else {
              this.nodata = false;
            }
          });
      }
    },
    inputboxfocus() {
      this.searchbutton = true;
      this.datepickshow = false;
    },
    dosearch() {
      if (this.search.trim() != "") {
        this.setvisualflag("loading");
        this.page = 1;
        this.date = "";
        this.searchbutton = false; //, (this.datepickshow = true);
        this.$request
          .searchfavorite(this.token, this.search.trim(), this.page)
          .then(response => {
            var flag = this.checkresponse(response);
            this.checkflag(flag);
          });
      } else {
        this.searchbutton = false; //, (this.datepickshow = true);
      }
    },
    async fetchtoken() {
      try {
        var token = await clientApplication.acquireTokenSilent(
          applicationConfig.b2cScopes,
          applicationConfig.authority
        );
        this.token = token;
      } catch (error) {
        this.token = "";
        this.loginerror = true;
        this.load = false;
      }
    },
    async homefavorite(weiboID, isfavorite, item) {
      console.log(weiboID);
      if (!isfavorite) {
        var res = await this.$request.setfavorite(this.token, weiboID);
        if (res.status == 201) {
          this.$notify({
            title: "收藏成功",
            // message: "已加入收藏",
            type: "success"
          });
          item.favorite = true;
        } else {
          this.$notify.error({
            title: "错误",
            message: "收藏失败"
          });
        }
      } else {
        var res = await this.$request.rmfavorite(this.token, weiboID);
        if (res.status == 204) {
          this.$notify({
            title: "已移除收藏",
            // message: "已加入收藏",
            type: "success"
          });
          item.favorite = false;
        } else {
          this.$notify.error({
            title: "错误",
            message: "收藏移除失败"
          });
        }
      }
    },
    loaddata() {
      if (this.token == "") {
        this.loginerror = true;
        this.load = false;
      } else {
        this.$request.favorite(this.token).then(response => {
          var flag = this.checkresponse(response);
          this.checkflag(flag);
          this.loginerror = false;
        });
      }
    },
    checkresponse(response) {
      if (!response) {
        return "error";
      }
      var statuscode = response.status;
      if (statuscode == 404) {
        return null;
      } else if (statuscode == 200) {
        return response.data;
      } else if (statuscode == 201) {
        return "Created";
      } else if (statuscode == 202) {
        return "NoContent";
      } else if (statuscode == 204) {
        return "Accepted";
      } else {
        return "error";
      }
    },
    setvisualflag(status) {
      if (status == "neterror") {
        this.load = false; //正在加载
        this.nodata = false; //没有这一天的数据
        this.nomore = false; //不能加载到更多
        this.loaderror = true; //加载失败
        this.nosearch = false;
        this.nocollection = false;
      } else if (status == "nomore") {
        this.load = false;
        this.nodata = false;
        this.nomore = true;
        this.loaderror = false;
        this.nosearch = false;
        this.nocollection = false;
        this.page--;
        this.$message({
          showClose: true,
          message: "没有了::>_<::",
          type: "error"
        });
      } else if (status == "loading") {
        this.load = true;
        this.nodata = false;
        this.nomore = false;
        this.loaderror = false;
        this.nosearch = false;
        this.nocollection = false;
      } else if (status == "success") {
        this.load = false;
        this.nodata = false;
        this.nomore = false;
        this.loaderror = false;
        this.nocollection = false;
      } else if (status == "noday") {
        this.info = null;
        this.load = false;
        this.nodata = true;
        this.nomore = false;
        this.loaderror = false;
        this.nosearch = false;
        this.nocollection = false;
      } else if (status == "nosearch") {
        this.info = null;
        this.load = false;
        this.nodata = false;
        this.nomore = false;
        this.loaderror = false;
        this.nosearch = true;
        this.nocollection = false;
      } else if (status == "nocollection") {
        this.info = null;
        this.load = false;
        this.nodata = false;
        this.nomore = false;
        this.loaderror = false;
        this.nosearch = false;
        this.nocollection = true;
      } else {
        this.load = true;
        this.nodata = false;
        this.nomore = false;
        this.loaderror = false;
        this.nosearch = false;
        this.nocollection = false;
      }
    },
    checkflag(flag) {
      if (flag == null && this.page == 1 && this.search != "") {
        this.setvisualflag("nosearch");
      } else if (flag != null && flag.length == 0) {
        this.setvisualflag("nocollection");
      } else if (flag == null || flag.length == 0) {
        //没有更多数据
        this.setvisualflag("nomore");
      } else if (flag == "error") {
        this.setvisualflag("neterror");
      } else {
        this.info = flag;
        this.setvisualflag("success");
      }
    }
  },
  filters: {}
};
</script>
<style lang="scss" scoped>
@import "../style/stylehome.css";
.el-alert {
  justify-content: center;
}

#wbcontent {
  column-count: 1;
  column-gap: 0;
  @media screen and (min-width: 500px) {
    column-count: 1;
  }
  @media screen and (min-width: 700px) {
    column-count: 2;
  }
  @media screen and (min-width: 1200px) {
    column-count: 3;
  }
  @media screen and (min-width: 1500px) {
    column-count: 4;
  }
  .list-complete-item {
    transition: all 1s;
    display: inline-block;
    margin-right: 10px;
  }
  .list-complete-enter, .list-complete-leave-to
/* .list-complete-leave-active for below version 2.1.8 */ {
    opacity: 0;
    transform: translateY(30px);
  }
  .list-complete-leave-active {
    position: absolute;
  }
}
.el-button-group {
  margin: 10px auto;
}
#myapp {
  margin-bottom: 20px;
}
.loaderror {
  color: #f56c6c;
  font-size: 16px;
}
.topinput {
  display: flex;
  justify-content: space-around;
}
.toparea {
  display: flex;
  justify-content: center;
}
.search {
  display: flex;
  transition: 1s;
}
.inputbox {
  margin: 0 10px;
}
// .datetrans-enter-active,
// .datetrans-leave-active {
//   transition: all 0.3s;
// }
// .datetrans-enter,
// .datetrans-leave-to {
//   opacity: 0;
//   transform: translateX(-10px);
// }
// .datetrans-item {
//   display: inline-block;
// }
</style>



// WEBPACK FOOTER //
// src/components/Favorites.vue